module.exports = __webpack_public_path__ + "img/prix.ca27ba2b.jpg";